import React from 'react'
import Navbarmenu from './Navbarmenu';
import './SpecializationContent.css';
import Container from '@material-ui/core/Container';

 function SpecializationContent() {
    return (
        <>
            <div className="main-container" id="specializationcontent-box">
                <title>Security Learning - Specialization</title>
                <img src={process.env.PUBLIC_URL +"/images/entry-level-banner.png"} className="banner-img"/>
                <Navbarmenu/>
            </div>
            <Container className='specialization-container' maxWidth="xl">
                {/* section-1 */}
                {/* <p>Here is the Security learning guidance for entry and lateral resources to equip with the knowledge of some of the key security aspects as applicable to the different phases of SDLC. For security specialists playing security roles, there is a focus on deeper aspects of security learning.</p> */}
                <div className="specialization-wrap">
                    <h3>Security specialization Learning (Security Roles)</h3>
                </div>
                {/* section-2 */}
                <div className="learning-format-wrap">
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <img src={process.env.PUBLIC_URL +"/images/Security-Domain-Based-Learnings.png"} alt="security-learning" className="learn-format-img" />
                            <h2>Security Domain Based Learnings</h2>
                            <p>Security Specializations and Skills according to Domain and Industry </p>
                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <img src={process.env.PUBLIC_URL +"/images/Localizing-Security-Schools.png"} alt="security-learning" className="learn-format-img" />
                            <h2>Localizing Security Schools </h2>
                            <p>Localizing the security schools for ATCI employees</p>
                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <img src={process.env.PUBLIC_URL +"/images/Security-Certification.png"} alt="security-learning" className="learn-format-img" />
                            <h2>Security Certification</h2>
                            <p>Creating an ecosystem for ATCI employees to get certified for different security offerings <span><a href="https://in.accenture.com/protectingaccenture/dashboard/" target="_blank">For More Details</a></span> </p>
                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <img src={process.env.PUBLIC_URL +"/images/Need-Based-Security-Learnings-new.png"} alt="security-learning" className="learn-format-img" />
                            <h2>Need Based Security Learnings</h2>
                            <p>Create Trainer Pool and Increase Security SMEs  </p>
                        </div>
                    </div>
                </div>
            </Container>
        </>
    )
}
export default SpecializationContent;